import {$} from "../../Application";
import {Page} from "../../Page";

export class EditTable extends Page {
    onReady(): void {
        const $tableColumnList = $('.table-column-list');
        $tableColumnList.sortable({
            update: function() {
                $('.table-column-list input[name$="[sequence]"]').each(function(i) {
                    console.log('set', i);
                    $(this).val(i);
                });
            },
        });
        $tableColumnList.on('change', 'input[type=checkbox]', function(e) {
            $(e.currentTarget).closest('li').toggleClass('column-hidden', $(this).is(':checked'));
        });
        $tableColumnList.find('input[type=checkbox]').each(function(i, elem) {
            $(elem).closest('li').toggleClass('column-hidden', $(elem).is(':checked'));
        });
    }

    registerEventHandlers() {
    }

    runOnCurrentPage(): boolean {
        return $('form.form-tables').length > 0;
    }
}
